// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"ZoomImage_backdrop__iUjh2","container":"ZoomImage_container__uW3uD","image":"ZoomImage_image___fkaJ","zoomLink":"ZoomImage_zoomLink__1czb7"};